module.exports = __webpack_public_path__ + "img/loading-bg.e2c313e2.png";